import { Module } from 'vuex'

import { RootState } from '../types'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { UserState } from './types'

const userModule: Module<UserState, RootState> = {
  namespaced: true,

  actions,
  getters,
  mutations,

  state: {
    isEmailPendingVerification: false,
    isPasswordSet: true,
    isOneTimeLoginSession: false,
    serviceRequest: null,
    contract: null,
    userDetails: null,
  },
}

export default userModule
